import { render, staticRenderFns } from "./BankEmployeeNew.vue?vue&type=template&id=218d45d6&"
import script from "./BankEmployeeNew.vue?vue&type=script&lang=js&"
export * from "./BankEmployeeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QField,QCheckbox,QInput,QSelect,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QField,QCheckbox,QInput,QSelect,QSeparator,QCardActions})
